export const validateKuwaitIBAN = (iban: string, expectedBankIdentifier: string): boolean => { 
    const cleanIBAN = iban.replace(/\s+/g, '').toUpperCase();
    const cleanBankIdentifier = expectedBankIdentifier.toUpperCase();
 
    if (cleanIBAN.length !== 30) {
        return false;
    }
 
    if (!cleanIBAN.startsWith('KW')) {
        return false;
    }
 
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{26}$/.test(cleanIBAN)) {
        return false;
    }
 
    const bankIdentifier = cleanIBAN.slice(4, 8);
    if (bankIdentifier !== cleanBankIdentifier) {
        return false;
    }
 
    const rearranged = cleanIBAN.slice(4) + cleanIBAN.slice(0, 4);
    const numericIBAN = rearranged
        .split('')
        .map(char => (isNaN(Number(char)) ? (char.charCodeAt(0) - 55).toString() : char))
        .join('');
 
    const numericBigInt = BigInt(numericIBAN);
    const mod97 = numericBigInt % BigInt(97);
    if (mod97 !== BigInt(1)) {
        return false;
    } 
    return true;
};
